<template>
  <div v-if="currentPerson" class="passport_fill">
    <el-row class="text_fill">
      <el-col :span="12">
        <div class="h_rate">
          <h3>Перевозчик</h3>
          <el-rate v-model="rate_user" disabled :colors="rate_color" />
        </div>
        <ul class="contact_user_list">
          <li>
            <div class="param_name">Компания:</div>
            <div class="param_driver">
              {{ currentPerson.auto.carrier_name || 'нет данных' }}
            </div>
          </li>
          <li>
            <div class="param_name">ИНН:</div>
            <div class="param_driver">
              {{ currentPerson.auto.carrier_inn || 'нет данных' }}
            </div>
          </li>
          <li>
            <div class="param_name">Номер договора:</div>
            <div class="param_driver">
              <p>{{ contractNum }}</p>
              <br />
              <a
                v-if="contractId"
                href
                class="company_name"
                @click.prevent="getZipContract(contractId)"
              >
                Скачать документы
              </a>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :span="12" class="second_part">
        <h3>Текущее предложение:</h3>
        <div class="active_price">
          <p v-if="type !== 'harvest'">
            {{ currentPerson.price_from_storage_driver | getPrice }}
            <span v-if="type === 'harvest_or_delivery'"> (Перевозка) </span>
          </p>
          <p v-if="type !== 'delivery'">
            {{ currentPerson.price_from_field_driver | getPrice }}
            <span v-if="type === 'harvest_or_delivery'"> (Уборка) </span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-row class="text_fill text_fill_2">
      <el-col :span="12">
        <h3>Автомобиль</h3>
        <ul class="contact_user_list">
          <li>
            <div class="param_name">Номер автомобиля:</div>
            <div class="param_driver">
              {{ currentPerson.auto.state_numbers || 'нет данных' }}
            </div>
          </li>
          <li>
            <div class="param_name">Основание владения:</div>
            <div class="param_driver">
              {{ isOwn(currentPerson.auto) ? 'cобственник' : 'аренда/лизинг' }}
            </div>
          </li>
          <li>
            <div class="param_name">Собственник:</div>
            <div class="param_driver">
              {{ currentPerson.auto.name_owner || 'нет данных' }}
            </div>
          </li>
          <li v-if="currentPerson.auto.vin_auto">
            <div class="param_name">VIN номер:</div>
            <div class="param_driver">
              {{ currentPerson.auto.vin_auto }}
            </div>
          </li>
          <li v-if="currentPerson.auto.ctc_auto">
            <div class="param_name">СТС номер:</div>
            <div class="param_driver">
              {{ currentPerson.auto.ctc_auto }}
            </div>
          </li>
          <li>
            <div class="param_name" />
            <div class="param_driver" style="line-height: 18px">
              <el-link
                href=""
                type="primary"
                class="company_name"
                @click.prevent="innerVisibleMap = true"
              >
                Местоположение
              </el-link>
              <br />
              <el-link
                href=""
                type="primary"
                class="company_name"
                @click.prevent="getZipAutos(currentPerson.auto.id)"
              >
                Скачать документы
              </el-link>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <h3>Прицеп</h3>
        <ul class="contact_user_list">
          <li>
            <div class="param_name">Номер прицепа:</div>
            <div class="param_driver">
              {{ currentPerson.auto.state_numbers_trailer || 'нет данных' }}
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row class="text_fill text_fill_2">
      <el-col :span="12">
        <div class="h_rate h_rate_second">
          <h3>Водитель</h3>
          <el-rate v-model="rate_user" disabled :colors="rate_color" />
        </div>
        <ul class="contact_user_list">
          <li>
            <div class="param_name">Телефон:</div>
            <div class="param_driver">
              <el-link
                href="tel:+79034514026"
                type="primary"
                class="link_phone"
                @click.prevent="getZipAutos(currentPerson.auto.id)"
              >
                {{ currentPerson.driver.phone || 'нет данных' }}
              </el-link>
            </div>
          </li>
          <li>
            <div class="param_name">ФИО:</div>
            <div class="param_driver">
              {{ currentPerson.driver.fio || 'нет данных' }}<br />
            </div>
          </li>
          <li>
            <div class="param_name" />
            <div class="param_driver">
              <el-link
                href=""
                type="primary"
                class="company_name"
                @click.prevent="getZipDriver(currentPerson.driver.id)"
              >
                Скачать документы
              </el-link>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row class="param_driver ml-145">
      <el-link
        href=""
        type="primary"
        class="company_name"
        @click.prevent="getZipAll"
      >
        Скачать все документы по авто
      </el-link>
    </el-row>
    <el-dialog
      title="Информация о компании"
      :width="isMobile ? '95%' : '42%'"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div>Информация о компании</div>
    </el-dialog>
    <el-dialog
      title="Местоположение"
      :width="isMobile ? '95%' : '42%'"
      :visible.sync="innerVisibleMap"
      append-to-body
    >
      <one-car-map :current-person="currentPerson" :coords="coords" />
    </el-dialog>
    <auto-edit
      :edit-auto="editAuto"
      :current-person="currentPerson"
      @closedCustom="setENull"
      @updated="updateAuto"
    />
    <driver-edit
      :edit-driver="editDriver"
      :close-modal="closeModal"
      :dialog-visible="dialogVisible"
      :current-person="currentPerson"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { UPDATE_DRIVER } from '@/store/actions/drivers'
import { mapGetters } from 'vuex'
import AutoEdit from '@/views/Autopark/Auto-edit'
import DriverEdit from '@/views/Driver/Driver-edit'
import OneCarMap from '../Maps/OneCarMap'

const responsesRepository = RepositoryFactory.get('responses')
const Document = RepositoryFactory.get('document')
const contractsRepository = RepositoryFactory.get('contractsRepository')

import { MAIN_ORGANIZATION_DATA } from '@/datas/consts'

export default {
  name: 'PassportFill',
  components: { OneCarMap, AutoEdit, DriverEdit },
  props: {
    currentPerson: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      innerVisible: false,
      innerVisibleMap: false,
      rate_user: 3,
      rate_color: ['#2ECC71', '#2ECC71', '#2ECC71'],
      editDriver: {},
      editAuto: {},
      auto: '',
      dialogVisible: false,
      items: {},
      coords: {},
      contractNum: '',
      contractId: 0,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/userInfo',
    }),
    isOwn() {
      return auto => auto.carrier_inn === auto.inn_owner
    },
  },
  watch: {
    currentPerson: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (newVal.id) {
            responsesRepository
              .getCoords({ id: newVal.id })
              .then(res => {
                const { items } = res.data

                if (items && items.length) {
                  this.coords = items[0].coords
                }
              })
              .catch(err => this.errHandler(err))
          }
          if (newVal.auto?.carrier_inn) {
            contractsRepository
              .findContractsByInn(
                newVal.auto.carrier_inn,
                MAIN_ORGANIZATION_DATA.inn,
              )
              .then(res => {
                const { items } = res.data

                if (items && items[0]) {
                  this.contractId = 0
                  Document.get(items[0].document_id)
                    .then(docRes => {
                      const { data } = docRes

                      if (data.number) {
                        this.contractNum = data.number
                        this.contractId = data.id
                      } else {
                        this.contractNum = 'н/д'
                      }
                    })
                    .catch(err => this.errHandler(err))
                } else {
                  this.contractId = 0
                  this.contractNum = 'н/д'
                }
              })
              .catch(err => this.errHandler(err))
          }
        }
      },
    },
  },
  methods: {
    getZipAll() {
      const filename = `Документы по предложению id ${this.currentPerson.id}.zip`

      this.getZip('responses_docs', this.currentPerson.id, filename)
    },
    getZipAutos() {
      const filename =
        'Документы по авто ' + this.currentPerson.auto.state_numbers + '.zip'

      this.getZip('autos', this.currentPerson.auto.id, filename)
    },
    getZipContract(contractId) {
      const filename = 'Документы по договору ' + this.contractNum + '.zip'

      Document.getZip(contractId, filename)
        .then(response => {
          this.forceFileDownload(response, filename)
        })
        .catch(() => this.$alert('Нет файлов для скачивания'))
    },
    getZipDriver() {
      let filename =
        'Документы по водителю ' + this.currentPerson.driver.fio + '.zip'

      this.getZip('drivers', this.currentPerson.driver.id, filename)
    },
    getZip(source, id, filename) {
      Document.getZipByLink(source, id)
        .then(response => {
          this.forceFileDownload(response, filename)
        })
        .catch(() => this.$alert('Нет файлов для скачивания'))
    },
    infoDriver(driver, e, flag = false) {
      if (this.isMobile && !flag) {
        return false
      }
      const val = e.target.classList.value

      if (!e.target.dataset.goal && val.indexOf('el-checkbox') === -1) {
        this.editDriver = driver
        this.dialogVisible = true
      }
    },
    closeModal(driver, id) {
      if (driver) {
        this.$store.commit(`drivers/${UPDATE_DRIVER}`, { id, driver })
        this.filteredDriverList()
      }
      this.dialogVisible = false
    },
    updateAuto(data) {
      for (let auto of this.auto_list) {
        if (Number(auto.id) === Number(data.idAuto)) {
          for (let dataId in data.data) {
            auto[dataId] = data.data[dataId]
          }
        }
      }
    },
    setENull() {
      this.editAuto = { id: 0 }
    },
    setE(auto) {
      this.editAuto = auto
    },
  },
}
</script>

<style lang="sass">
.passport_dialog_window
  .el-dialog
    max-width: 800px

.passport_fill
  font-family: "Rubik", sans-serif
  padding: 40px 10px 0
  *:not(button)
    padding: 0
    margin: 0
  .text_fill
    margin-bottom: 36px
    &:last-of-type
        margin-bottom: 0
  h3
    font-size: 16px
    font-weight: bold
    color: #000000
    margin-bottom: 15px
  .param_name
    color: #9D9D9D
    letter-spacing: 0.5px
    min-width: 110px
  .param_driver
    color: #000000
    .link_phone
      color: #000000
      font-size: 12px
      text-decoration: none
    a
      text-decoration: underline
    &.ml-145
      margin-left: 145px
  .contact_user_list
    li
      font-size: 12px
      margin-bottom: 14px
      display: flex
      &:last-child
        margin-bottom: 0
  .second_part
    text-align: right
  .rate_list
    li
      margin-top: 7px
      color: #9D9D9D
      font-size: 14px
      text-decoration: line-through
      &:first-child
        margin-top: 0
  .text_fill_2
    .param_name
      min-width: 140px
      margin-right: 5px
  .h_rate
    display: flex
    h3
      margin-right: 24px
  .h_rate_second
    h3
      min-width: 118px
  ul
    list-style: none
  .current_price
    margin-top: 12px
    color: #3498DB
    font-size: 48px
    font-weight: bold
    text-decoration: none
    span
      font-size: 16px
      letter-spacing: 0.5px
  a.company_name
    font-size: 12px
    &:hover
      &:after
        display: none
  .active_price
    margin-top: 12px
    color: #3498DB
    font-size: 30px
    font-weight: bold
    text-decoration: none
    span
      font-size: 16px
      letter-spacing: 0.5px

.el-dialog__title
  font-family: "Rubik", sans-serif
</style>
